module.exports = __webpack_public_path__ + "media/images/admin/icons/edit-3-484334b2ee6ccb0be4c634af3bd7dcca.svg";